export const displayPrice = (price: number) => {
  const priceInDollars = price / 100;
  return priceInDollars.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
